var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gov"},[_c('DevBannersView',{attrs:{"id":"dev","timestamp":_vm.timestamp}}),_c('SectionXidCanDo'),_c('SectionGlobalStandard'),_c('SectionOtherCooperation'),_c('SectionDevContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }